import { render, staticRenderFns } from "./centerbg.vue?vue&type=template&id=11820855&scoped=true"
import script from "./centerbg.vue?vue&type=script&lang=js"
export * from "./centerbg.vue?vue&type=script&lang=js"
import style0 from "./centerbg.vue?vue&type=style&index=0&id=11820855&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11820855",
  null
  
)

export default component.exports